import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { Container, Header, Wrapper } from '../../../components_renew/Layout'
import { TabBar } from '../../../components_renew/Mall/TabBar'
import { ProductSearchBar } from '../../../components_renew/Mall/ProductSearchBar'
import { HomeList } from './List'
import { Banner } from './Banner'
import { CatalogsBlock } from './CatalogsBlock'
import { HotSale } from './HotSale'
import { clearProductListSearch, requestProductListData } from '../../../actions/mallAction'

@withRouter
@connect()
class Search extends React.PureComponent {
  render () {
    return <ProductSearchBar onSearch={this.onSearchSubmit} placeholder={'请输入商品名称'}/>
  }

  onSearchSubmit = keyword => {
    const { dispatch, history } = this.props
    dispatch(clearProductListSearch())
    dispatch(requestProductListData({ index: 'search', pageIndex: 1, keyword }))
    history.push(window.PATH.MALL_PRODUCT_SEARCH)
  }
}

@withTranslation()
class MallHome extends React.PureComponent {
  render () {
    const { t } = this.props
    return <Container>
      <Header>{t('mall.title')}</Header>
      <Wrapper flex>
        <HomeList>
          <Search/>
          <Banner/>
          <br/>
          <CatalogsBlock/>
          <br/>
          <HotSale/>
          <br/>
        </HomeList>
        {/*<HomeList>*/}
        {/*  <Search/>*/}
        {/*  <Banner/>*/}
        {/*  <br/>*/}
        {/*  <CatalogsBlock/>*/}
        {/*  <br/>*/}
        {/*  <HotSale/>*/}
        {/*  <br/>*/}
        {/*</HomeList>*/}
      </Wrapper>
      <TabBar selectedKey={'home'}/>
    </Container>
  }
}

export { MallHome }
